import * as React from "react";
import { IconProps } from "./types";

export const ChevronLeftDoubleIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M18 17L13 12L18 7M11 17L6 12L11 7"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(ChevronLeftDoubleIcon as React.FunctionComponent).displayName =
  "ChevronLeftDoubleIcon";

export default ChevronLeftDoubleIcon;
